const options = {
  5: "bg-pink-200/5",
  10: "bg-pink-200/10",
  25: "bg-pink-200/25",
  50: "bg-pink-200/50",
  75: "bg-pink-200/75",
  90: "bg-pink-200/90",
  100: "bg-pink-200",
};

const from = {
  5: "from-pink-200/5",
  10: "from-pink-200/10",
  25: "from-pink-200/25",
  50: "from-pink-200/50",
  75: "from-pink-200/75",
  90: "from-pink-200/90",
  100: "from-pink-200",
};

export default function getBackgroundPink200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
